import { NotificationCenter } from "@eworkit/messenger";
import React, { FC } from "react";

interface NotificationsPageProps {}

export const NotificationsPage: FC<NotificationsPageProps> = () => <NotificationCenter />;
